import { BRAND_LOGO } from '../brand';
import { useStore } from '../state/store';

export interface ComingSoonScreenProps {
  title: string;
  description: string;
}

/**
 * 未実装機能の共通プレースホルダ。
 * 既存の card / btn スタイルだけを使い、新規デザイン体系は導入しない。
 */
export function ComingSoonScreen({ title, description }: ComingSoonScreenProps) {
  const setView = useStore((s) => s.setView);

  return (
    <div className="library-shell flex h-full flex-col">
      <header className="pt-safe-header shrink-0 border-b border-base-600/60 bg-[#07090f] px-4 pb-3 md:hidden landscape:hidden">
        <h1 className="brand-mark text-lg font-semibold tracking-tight text-white">{title}</h1>
      </header>

      <div className="flex min-h-0 flex-1 items-center justify-center overflow-y-auto px-4 py-8 pb-[calc(5.5rem+env(safe-area-inset-bottom,0px))] md:pb-8 landscape:pb-8">
        <div className="card w-full max-w-md p-6 text-center sm:p-8">
          <p className="font-display text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-accent">
            Coming Soon
          </p>
          <h2 className="brand-mark mt-3 text-2xl font-semibold text-white">{title}</h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-400">{description}</p>
          <p className="mt-6 text-[0.7rem] text-slate-600" aria-label={BRAND_LOGO}>
            EmYu-Ba
          </p>
          <button type="button" className="btn-primary mt-6 w-full sm:w-auto sm:px-8" onClick={() => setView('home')}>
            Home に戻る
          </button>
        </div>
      </div>
    </div>
  );
}
